import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import * as constants from '../../static/constants'

interface IUserListItem {
  children: React.ReactNode
}

const ListBlock: React.VFC<IUserListItem> = ({ children }) => {
  return <S.ListBlock>{children}</S.ListBlock>
}

const S: { [key: string]: AnyStyledComponent } = {}

S.ListBlock = styled.div`
  gap: 16px;
  width: 100%;
  border: 1px solid ${constants.COLORS.divider};
  padding: 16px;
  border-radius: 4px;

  & + & {
    margin-top: 16px;
  }

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    border: none;
    border-bottom: 1px solid ${constants.COLORS.divider};
    padding: 16px 0;
  }
`

export default ListBlock
